import {
  Model,
} from '@vuex-orm/core';

export default class extends Model {
  static entity = 'form'

  static fields() {
    return {
      id: this.string(''),
      type: this.string(''),
      form: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/api',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/forms',
          method: 'get',
        },
      },
      $get: {
        name: 'get',
        http: {
          url: '/forms/:id',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/forms',
          method: 'post',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/forms/:id',
          method: 'put',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/forms/:id',
          method: 'delete',
        },
      },
    },
  }
}
